/* PressMart-Shopify — base theme interactions */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var body = document.body;
    var overlay = document.querySelector('[data-overlay]');
    var drawer = document.querySelector('[data-drawer]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      body.classList.add('drawer-open');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      body.classList.remove('drawer-open');
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Mobile submenu expanders
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('li');
        if (li) li.classList.toggle('is-expanded');
      });
    });

    // Category menu toggle (desktop)
    document.querySelectorAll('[data-cat-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var menu = btn.closest('[data-cat-menu]');
        if (menu) menu.classList.toggle('is-open');
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('[data-cat-menu].is-open').forEach(function (m) {
        m.classList.remove('is-open');
      });
    });

    // Promo bar dismiss
    var promo = document.querySelector('[data-promo-bar]');
    var promoClose = document.querySelector('[data-promo-close]');
    if (promo && sessionStorage.getItem('promoClosed') === '1') {
      promo.style.display = 'none';
    }
    if (promoClose) {
      promoClose.addEventListener('click', function () {
        promo.style.display = 'none';
        sessionStorage.setItem('promoClosed', '1');
      });
    }

    // ---------- Slideshow ----------
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var track = root.querySelector('[data-slides]');
      var slides = root.querySelectorAll('[data-slide]');
      var dotsWrap = root.querySelector('[data-slide-dots]');
      if (!track || slides.length < 2) return;
      var index = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
      var timer;

      // dots
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'slideshow__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { go(i); });
        if (dotsWrap) dotsWrap.appendChild(dot);
      });

      function update() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.slideshow__dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
          });
        }
      }
      function go(i) { index = (i + slides.length) % slides.length; update(); restart(); }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function restart() { if (!autoplay) return; clearInterval(timer); timer = setInterval(next, speed); }

      var nextBtn = root.querySelector('[data-slide-next]');
      var prevBtn = root.querySelector('[data-slide-prev]');
      if (nextBtn) nextBtn.addEventListener('click', next);
      if (prevBtn) prevBtn.addEventListener('click', prev);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);
      update();
      restart();
    });

    // ---------- AJAX add to cart ----------
    document.querySelectorAll('[data-cart-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn) btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: new URLSearchParams(new FormData(form))
        })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1500); }
            if (window.__cart) window.__cart.refresh().then(window.__cart.open);
          })
          .catch(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });

    // ---------- Wishlist (localStorage) ----------
    function readWishlist() { try { return JSON.parse(localStorage.getItem('wishlist') || '[]'); } catch (e) { return []; } }
    function paintWishlistCount() {
      var n = readWishlist().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = n; });
    }
    document.querySelectorAll('[data-add-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-id');
      if (readWishlist().indexOf(id) !== -1) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        var list = readWishlist();
        var pos = list.indexOf(id);
        if (pos === -1) { list.push(id); btn.classList.add('is-active'); }
        else { list.splice(pos, 1); btn.classList.remove('is-active'); }
        localStorage.setItem('wishlist', JSON.stringify(list));
        paintWishlistCount();
      });
    });
    paintWishlistCount();

    // ---------- Wishlist page (renders saved products) ----------
    (function () {
      var page = document.querySelector('[data-wishlist-page]');
      if (!page) return;
      var grid = page.querySelector('[data-wishlist-grid]');
      var empty = page.querySelector('[data-wishlist-empty]');
      var loading = page.querySelector('[data-wishlist-loading]');

      function money(cents) {
        var fmt = window.themeMoneyFormat || '₹{{amount}}';
        function withCommas(num) {
          var parts = num.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return parts.join('.');
        }
        var value = (cents / 100);
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
          switch (name) {
            case 'amount': return withCommas(value.toFixed(2));
            case 'amount_no_decimals': return withCommas(value.toFixed(0));
            case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',');
            case 'amount_no_decimals_with_comma_separator': return value.toFixed(0);
            case 'amount_with_space_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            default: return withCommas(value.toFixed(2));
          }
        });
      }

      function cardHTML(p) {
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        var onSale = p.compare_at_price && p.compare_at_price > p.price;
        var priceHTML = onSale
          ? '<span class="price price--sale">' + money(p.price) + '</span> <s class="price price--compare">' + money(p.compare_at_price) + '</s>'
          : '<span class="price">' + money(p.price) + '</span>';
        return '' +
          '<div class="product-card" data-product-card data-wishlist-item="' + p.handle + '">' +
            '<div class="product-card__media">' +
              '<a href="' + p.url + '" class="product-card__image-link">' +
                (img ? '<img class="product-card__image product-card__image--primary" src="' + img + '" alt="' + (p.title || '') + '" width="500" height="500" loading="lazy">' : '') +
              '</a>' +
              '<div class="product-card__actions">' +
                '<button type="button" class="product-card__action is-active" data-wishlist-remove="' + p.handle + '" aria-label="Remove">✕</button>' +
              '</div>' +
            '</div>' +
            '<div class="product-card__info">' +
              '<h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
              '<div class="product-card__price">' + priceHTML + '</div>' +
            '</div>' +
          '</div>';
      }

      function finish(handles) {
        if (loading) loading.hidden = true;
        if (!handles.length) {
          if (empty) empty.hidden = false;
          if (grid) grid.hidden = true;
          return;
        }
        if (grid) grid.hidden = false;

        var fetches = handles.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        });

        Promise.all(fetches).then(function (products) {
          var valid = products.filter(Boolean);
          // Drop any handles that no longer resolve (deleted/unpublished products)
          var validHandles = valid.map(function (p) { return p.handle; });
          if (validHandles.length !== handles.length) {
            localStorage.setItem('wishlist', JSON.stringify(validHandles));
            paintWishlistCount();
          }
          if (!valid.length) {
            if (empty) empty.hidden = false;
            if (grid) grid.hidden = true;
            return;
          }
          grid.innerHTML = valid.map(cardHTML).join('');
        });
      }

      finish(readWishlist());

      // Remove from wishlist on this page
      if (grid) {
        grid.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-wishlist-remove]');
          if (!btn) return;
          e.preventDefault();
          var handle = btn.getAttribute('data-wishlist-remove');
          var list = readWishlist();
          var pos = list.indexOf(handle);
          if (pos !== -1) { list.splice(pos, 1); localStorage.setItem('wishlist', JSON.stringify(list)); }
          paintWishlistCount();
          var card = btn.closest('[data-wishlist-item]');
          if (card) card.remove();
          if (!grid.children.length) { grid.hidden = true; if (empty) empty.hidden = false; }
        });
      }
    })();

    // ---------- Collection page ----------
    (function () {
      var root = document.querySelector('[data-collection]');
      if (!root) return;

      // Sort -> reload with sort_by param
      var sort = root.querySelector('[data-sort]');
      if (sort) {
        sort.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }

      // Filters -> auto-submit the filter form on change
      var form = root.querySelector('[data-filter-form]');
      if (form) {
        form.addEventListener('change', function (e) {
          if (e.target.matches('[data-filter-input]')) {
            var params = new URLSearchParams(new FormData(form));
            // drop empty values
            var clean = new URLSearchParams();
            params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
            window.location.search = clean.toString();
          }
        });
      }

      // Mobile filter drawer
      var drawer = root.querySelector('[data-filter-drawer]');
      root.querySelectorAll('[data-filter-open]').forEach(function (b) {
        b.addEventListener('click', function () { if (drawer) drawer.classList.add('is-open'); body.classList.add('drawer-open'); });
      });
      root.querySelectorAll('[data-filter-close]').forEach(function (b) {
        b.addEventListener('click', function () { if (drawer) drawer.classList.remove('is-open'); body.classList.remove('drawer-open'); });
      });

      // Grid / list view toggle
      var grid = root.querySelector('[data-product-grid]');
      root.querySelectorAll('[data-view-toggle] button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-view-toggle] button').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (grid) grid.classList.toggle('product-grid--list', btn.getAttribute('data-view') === 'list');
        });
      });
    })();

    // ---------- Product page ----------
    (function () {
      var page = document.querySelector('[data-product-page]');
      if (!page) return;

      // Gallery: thumb -> main image, with prev/next arrows
      var slides = page.querySelectorAll('[data-gallery-slide]');
      var thumbs = page.querySelectorAll('[data-gallery-thumb]');
      var galleryIndex = 0;
      function showImage(i) {
        i = parseInt(i, 10) || 0;
        if (slides.length) { i = (i + slides.length) % slides.length; }
        galleryIndex = i;
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-index') === String(i)); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showImage(t.getAttribute('data-index')); });
      });
      var galPrev = page.querySelector('[data-gallery-prev]');
      var galNext = page.querySelector('[data-gallery-next]');
      if (galPrev) galPrev.addEventListener('click', function () { showImage(galleryIndex - 1); });
      if (galNext) galNext.addEventListener('click', function () { showImage(galleryIndex + 1); });

      // Quantity stepper
      var qtyInput = page.querySelector('[data-qty-input]');
      var minus = page.querySelector('[data-qty-minus]');
      var plus = page.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });

      // Variant selection
      var variantSelect = page.querySelector('[data-variant-select]');
      var optionInputs = page.querySelectorAll('[data-option-input]');
      var priceAmount = page.querySelector('[data-price-amount]');
      var priceCompare = page.querySelector('[data-price-compare]');
      var addBtn = page.querySelector('[data-add-to-cart]');
      var addLabel = page.querySelector('[data-add-label]');
      var skuEl = page.querySelector('[data-sku]');

      var stickyPrice = page.querySelector('[data-sticky-price]');
      var stickyAdd = page.querySelector('[data-sticky-add]');
      var stickyBuy = page.querySelector('[data-sticky-buy]');
      var buyBtn = page.querySelector('[data-buy-now]');

      function selectedOptions() {
        var opts = [];
        page.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) opts.push(checked.value);
          // reflect selected styling (buttons + color swatches) + label
          group.querySelectorAll('.product-option__value, .product-swatch').forEach(function (l) {
            l.classList.toggle('is-selected', l.querySelector('input').checked);
          });
          var lbl = group.querySelector('[data-option-selected]');
          if (lbl && checked) lbl.textContent = checked.value;
        });
        return opts.join(' / ');
      }
      function updateVariant() {
        if (!variantSelect) return;
        var target = selectedOptions();
        var match = null;
        variantSelect.querySelectorAll('option').forEach(function (o) {
          if (o.getAttribute('data-options') === target) match = o;
        });
        if (!match) { optionInputs.forEach(function (i) { i.checked ? null : null; }); return; }
        variantSelect.value = match.value;
        if (priceAmount) priceAmount.textContent = match.getAttribute('data-price');
        var hasCompare = match.getAttribute('data-compare') && match.getAttribute('data-compare') !== match.getAttribute('data-price');
        if (priceCompare) priceCompare.style.display = hasCompare ? '' : 'none';
        var available = match.getAttribute('data-available') === 'true';
        if (addBtn) addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
        if (skuEl) skuEl.textContent = match.getAttribute('data-sku') || '';
        if (stickyPrice) stickyPrice.textContent = match.getAttribute('data-price');
        [stickyAdd, stickyBuy, buyBtn].forEach(function (b) { if (b) b.disabled = !available; });
        updateStock(match);
      }

      // Stock progress bar
      var stockBar = page.querySelector('[data-stock-bar]');
      function updateStock(opt) {
        if (!stockBar) return;
        var tracked = opt.getAttribute('data-tracked') === 'true';
        var inv = parseInt(opt.getAttribute('data-inventory'), 10);
        var max = parseInt(stockBar.getAttribute('data-max'), 10) || 50;
        var low = parseInt(stockBar.getAttribute('data-low'), 10) || 10;
        var fill = stockBar.querySelector('[data-stock-fill]');
        var text = stockBar.querySelector('[data-stock-text]');
        if (!tracked || isNaN(inv)) { if (text) text.textContent = 'In stock'; if (fill) fill.style.width = '60%'; stockBar.classList.remove('is-low'); return; }
        var pct = Math.min(100, Math.max(inv > 0 ? 5 : 0, Math.round(inv * 100 / max)));
        if (fill) fill.style.width = pct + '%';
        stockBar.classList.toggle('is-low', inv > 0 && inv <= low);
        if (text) {
          if (inv <= 0) text.textContent = 'Out of stock';
          else if (inv <= low) text.innerHTML = 'Hurry! Only <strong>' + inv + '</strong> left';
          else text.innerHTML = '<strong>' + inv + '</strong> in stock';
        }
      }

      optionInputs.forEach(function (i) { i.addEventListener('change', updateVariant); });

      // Live viewers counter (randomised, drifts over time)
      var viewers = page.querySelector('[data-viewers]');
      if (viewers) {
        var vMin = parseInt(viewers.getAttribute('data-min'), 10) || 5;
        var vMax = parseInt(viewers.getAttribute('data-max'), 10) || 30;
        var vCount = viewers.querySelector('[data-viewers-count]');
        function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
        var current = rand(vMin, vMax);
        if (vCount) vCount.textContent = current;
        setInterval(function () {
          current += rand(-2, 2);
          if (current < vMin) current = vMin;
          if (current > vMax) current = vMax;
          if (vCount) vCount.textContent = current;
        }, 4000);
      }

      // Tabs
      page.querySelectorAll('[data-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.getAttribute('data-tab');
          page.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          page.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === name); });
        });
      });

      // Add to cart (AJAX) — reuse global handler is fine, but bind here for product form
      var form = page.querySelector('[data-product-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn) addBtn.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
            body: new URLSearchParams(new FormData(form))
          })
            .then(function (r) { return r.json(); })
            .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
              if (addBtn) { addBtn.classList.remove('is-loading'); if (addLabel) { var prev = addLabel.textContent; addLabel.textContent = 'Added ✓'; setTimeout(function () { addLabel.textContent = prev; }, 1500); } }
              if (window.__cart) window.__cart.refresh().then(window.__cart.open);
            })
            .catch(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
        });
      }

      // Sticky "Add" → trigger the main form submit
      if (stickyAdd && form) {
        stickyAdd.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      // Buy now → add to cart, then go straight to checkout
      function buyNow(trigger) {
        if (!form) return;
        if (trigger) { trigger.disabled = true; trigger.classList.add('is-loading'); }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: new URLSearchParams(new FormData(form))
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { if (trigger) { trigger.disabled = false; trigger.classList.remove('is-loading'); } });
      }
      if (buyBtn) buyBtn.addEventListener('click', function () { buyNow(buyBtn); });
      if (stickyBuy) stickyBuy.addEventListener('click', function () { buyNow(stickyBuy); });
    })();

    // ---------- Cart drawer + cart page controller ----------
    function openCartDrawer() {
      var d = document.querySelector('[data-cart-drawer]');
      if (!d) return;
      d.classList.add('is-open');
      body.classList.add('drawer-open');
    }
    function closeCartDrawer() {
      var d = document.querySelector('[data-cart-drawer]');
      if (d) d.classList.remove('is-open');
      body.classList.remove('drawer-open');
    }
    function refreshCartDrawer() {
      return fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var mount = document.querySelector('[data-cart-drawer-mount]');
          if (mount && data['cart-drawer']) {
            mount.innerHTML = data['cart-drawer'];
            bindCartDrawer();
          }
        });
    }
    function refreshCartCounts() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
    }
    function changeLine(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return Promise.all([refreshCartDrawer(), refreshCartCounts()]);
      });
    }

    // expose for add-to-cart handlers
    window.__cart = { open: openCartDrawer, refresh: refreshCartDrawer, counts: refreshCartCounts };

    function bindCartDrawer() {
      document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCartDrawer); });
      document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
        input.addEventListener('change', function () { changeLine(input.getAttribute('data-key'), parseInt(input.value, 10) || 0); });
      });
      document.querySelectorAll('[data-cart-item]').forEach(function (row) {
        var minus = row.querySelector('[data-cart-minus]');
        var plus = row.querySelector('[data-cart-plus]');
        var input = row.querySelector('[data-cart-qty]');
        if (minus) minus.addEventListener('click', function () { changeLine(input.getAttribute('data-key'), Math.max(0, (parseInt(input.value, 10) || 0) - 1)); });
        if (plus) plus.addEventListener('click', function () { changeLine(input.getAttribute('data-key'), (parseInt(input.value, 10) || 0) + 1); });
      });
      document.querySelectorAll('[data-cart-remove]').forEach(function (b) {
        b.addEventListener('click', function () { changeLine(b.getAttribute('data-key'), 0); });
      });
    }
    bindCartDrawer();

    // Header cart icon opens drawer instead of navigating
    document.querySelectorAll('[data-cart-link]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
    });

    // Cart note auto-save (cart page)
    var note = document.querySelector('[data-cart-note]');
    if (note) {
      var t;
      note.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
        }, 600);
      });
    }

    // ---------- Back to top ----------
    (function () {
      var btn = document.querySelector('[data-back-to-top]');
      if (!btn) return;
      function toggle() { btn.classList.toggle('is-visible', window.scrollY > 400); }
      window.addEventListener('scroll', toggle, { passive: true });
      btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
      toggle();
    })();

    // ---------- Shoppable video slider ----------
    (function () {
      var root = document.querySelector('[data-shoppable]');
      if (!root) return;
      var track = root.querySelector('[data-shop-track]');
      var cards = root.querySelectorAll('[data-shop-card]');

      // arrows scroll the track
      var next = root.querySelector('[data-shop-next]');
      var prev = root.querySelector('[data-shop-prev]');
      function step() { var c = cards[0]; return c ? c.offsetWidth + 20 : 300; }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });

      // autoplay when visible, play/pause toggle
      cards.forEach(function (card) {
        var video = card.querySelector('[data-shop-video]');
        var playBtn = card.querySelector('[data-shop-play]');
        if (!video) return;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { video.play().catch(function () {}); }
              else { video.pause(); }
            });
          }, { threshold: 0.5 }).observe(video);
        }
        if (playBtn) playBtn.addEventListener('click', function () {
          if (video.paused) { video.play(); card.classList.add('is-playing'); }
          else { video.pause(); card.classList.remove('is-playing'); }
        });
        video.addEventListener('play', function () { card.classList.add('is-playing'); });
        video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      });
    })();

    // ---------- Testimonials slider (mobile) ----------
    (function () {
      var root = document.querySelector('[data-testimonials]');
      if (!root) return;
      var track = root.querySelector('[data-testi-track]');
      var cards = root.querySelectorAll('.testimonial-card');
      var dotsWrap = root.querySelector('[data-testi-dots]');
      if (!track || !dotsWrap || cards.length === 0) return;
      // build dots = one per card; clicking scrolls to it
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.className = 'testi-dot';
        dot.addEventListener('click', function () { track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
        dotsWrap.appendChild(dot);
      });
      var dots = dotsWrap.querySelectorAll('.testi-dot');
      function active() {
        var idx = 0, min = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < min) { min = d; idx = i; } });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      track.addEventListener('scroll', active, { passive: true });
      active();
    })();

    // ---------- Story carousel ----------
    (function () {
      var root = document.querySelector('[data-story-carousel]');
      if (!root) return;
      var track = root.querySelector('[data-story-track]');
      if (!track) return;
      function step() { return Math.max(track.clientWidth * 0.8, 200); }
      var prev = root.querySelector('[data-story-prev]');
      var next = root.querySelector('[data-story-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    })();

    // ---------- Footer accordion (mobile only) ----------
    (function () {
      var mq = window.matchMedia('(max-width: 749px)');
      document.querySelectorAll('[data-footer-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!mq.matches) return; // desktop: do nothing
          var col = btn.closest('.footer__col');
          if (col) col.classList.toggle('is-open');
        });
      });
    })();

    // ---------- Password page: reveal login ----------
    (function () {
      var toggle = document.querySelector('[data-password-toggle]');
      var loginBox = document.querySelector('[data-password-login]');
      if (!toggle || !loginBox) return;
      toggle.addEventListener('click', function (e) { e.preventDefault(); loginBox.hidden = !loginBox.hidden; });
    })();

    // ---------- Predictive search ----------
    (function () {
      var wrap = document.querySelector('[data-predictive-search]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-predictive-input]');
      var results = wrap.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      var debounce;

      function money(cents) {
        try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
      }
      function render(data) {
        var products = (data.resources.results.products || []);
        var articles = (data.resources.results.articles || []);
        var pages = (data.resources.results.pages || []);
        if (products.length + articles.length + pages.length === 0) {
          results.innerHTML = '<div class="predictive-results__empty">No matches found</div>';
          results.hidden = false;
          return;
        }
        var html = '';
        if (products.length) {
          html += '<div class="predictive-results__group"><span class="predictive-results__label">Products</span>';
          products.forEach(function (p) {
            var img = p.featured_image ? '<img src="' + p.featured_image.url + '" alt="" width="48" height="48">' : '';
            html += '<a class="predictive-item" href="' + p.url + '">' + img +
              '<span class="predictive-item__text"><strong>' + p.title + '</strong><span class="predictive-item__price">' + money(p.price_min) + '</span></span></a>';
          });
          html += '</div>';
        }
        [['Articles', articles], ['Pages', pages]].forEach(function (pair) {
          if (pair[1].length) {
            html += '<div class="predictive-results__group"><span class="predictive-results__label">' + pair[0] + '</span>';
            pair[1].forEach(function (it) {
              html += '<a class="predictive-item predictive-item--text" href="' + it.url + '">' + it.title + '</a>';
            });
            html += '</div>';
          }
        });
        html += '<a class="predictive-results__all" href="/search?q=' + encodeURIComponent(input.value) + '">View all results →</a>';
        results.innerHTML = html;
        results.hidden = false;
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounce);
        if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
        debounce = setTimeout(function () {
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url).then(function (r) { return r.json(); }).then(render).catch(function () {});
        }, 250);
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) results.hidden = true;
      });
      input.addEventListener('focus', function () { if (results.innerHTML) results.hidden = false; });
    })();

    // ---------- Account: login / recover toggle ----------
    (function () {
      var root = document.querySelector('[data-login]');
      if (!root) return;
      var loginView = root.querySelector('[data-login-view]');
      var recoverView = root.querySelector('[data-recover-view]');
      function show(view) {
        loginView.hidden = view !== 'login';
        recoverView.hidden = view !== 'recover';
      }
      root.querySelectorAll('[data-show-recover]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show('recover'); }); });
      root.querySelectorAll('[data-show-login]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show('login'); }); });
      if (window.location.hash === '#recover') show('recover');
    })();

    // ---------- Account: address forms ----------
    (function () {
      var root = document.querySelector('[data-addresses]');
      if (!root) return;
      root.querySelectorAll('[data-address-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-address-toggle');
          var form = document.getElementById('Address' + (id === 'new' ? 'New' : id));
          if (form) form.hidden = !form.hidden;
        });
      });
      root.querySelectorAll('[data-address-cancel]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-address-cancel');
          var form = document.getElementById('Address' + (id === 'new' ? 'New' : id));
          if (form) form.hidden = true;
        });
      });
      root.querySelectorAll('[data-confirm-delete]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { if (!confirm('Delete this address?')) e.preventDefault(); });
      });

      // Country -> province sync (uses data-provinces on country options)
      root.querySelectorAll('[data-country]').forEach(function (countrySel) {
        var provinceSel = countrySel.closest('.auth-card__row').querySelector('[data-province]');
        function populate() {
          var opt = countrySel.options[countrySel.selectedIndex];
          var provinces = [];
          try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
          provinceSel.innerHTML = '';
          if (provinces.length === 0) { provinceSel.closest('div').style.display = 'none'; return; }
          provinceSel.closest('div').style.display = '';
          provinces.forEach(function (p) {
            var o = document.createElement('option');
            o.value = p[0]; o.textContent = p[1];
            provinceSel.appendChild(o);
          });
          var def = provinceSel.getAttribute('data-default');
          if (def) provinceSel.value = def;
        }
        var defCountry = countrySel.getAttribute('data-default');
        if (defCountry) countrySel.value = defCountry;
        countrySel.addEventListener('change', populate);
        populate();
      });
    })();

    // ---------- Related products (recommendations API) ----------
    (function () {
      var block = document.querySelector('[data-related-products]');
      if (!block) return;
      var grid = block.querySelector('[data-related-grid]');
      if (grid && grid.children.length > 0) return; // SSR already filled
      var url = block.getAttribute('data-url') + '?section_id=related-products&product_id=' + block.getAttribute('data-product-id') + '&limit=' + block.getAttribute('data-limit');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-related-grid]');
          if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
        })
        .catch(function () {});
    })();
  });
})();
